<template>
  <mdb-popover
    v-if="obj"
    :trigger="trigger"
    :options="options"
    :append-to-body="true"
    :boundaries-selector="'body'"
    class="bridge8-popover"
  >
    <span slot="header" class="bridge8-popover-header">{{ headerPrefix }}{{ textCallback(obj) }}</span>
    <div slot="body">
      <mdb-tbl>
        <mdb-tbl-body>
          <tr
            v-for="(value, key) in getTableValues(obj)"
            :key="`popover-table-row-${key}`"
          >
            <td class="text-right bridge8-popover-table-cell bridge8-popover-table-cell-key">{{ key }}:</td>
            <td class="text-left bridge8-popover-table-cell bridge8-popover-table-cell-value" >
              <a v-if="key === 'email'" :href="`mailto:${value}`">{{ value }}</a>
              <a v-else-if="key === 'url'" :href="value">{{ value }}</a>
              <span v-else>{{ value }}</span>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <span :class="`reference-text reference-text-${trigger}`" slot="reference">{{ textCallback(obj) }}</span>
  </mdb-popover>
</template>

<script>
import { mdbPopover, mdbTbl, mdbTblBody } from 'mdbvue'
import { tableValues } from '../utils'

export default {
  name: 'Bridge8Popover',
  props: {
    obj: {
      type: Object,
      required: true
    },
    textCallback: {
      type: Function,
      required: false,
      default: obj => obj.name
    },
    fields: {
      type: [Array, Boolean],
      default: false
    },
    headerPrefix: {
      type: String,
      required: true
    },
    trigger: {
      type: String,
      required: false,
      default: 'hover',
      validator: str => ['click', 'hover'].includes(str)
    },
    options: {
      type: Object,
      required: false,
      default: function () {
        return {placement: 'right', boundary: 'viewport'}
      }
    }
  },
  methods: {
    getTableValues (obj) {
      return tableValues(obj, this.fields)
    }
  },
  components: {
    mdbPopover,
    mdbTbl,
    mdbTblBody
  }
}
</script>

<style lang="sass" scoped>
.reference-text
  &.reference-text-click
    text-decoration: blink underline
  &.reference-text-hover
    text-decoration: dotted underline

  &:hover
    cursor: pointer
</style>

<style lang="sass">
.popover
  font-size: 90%

  .popover-header
    background-color: transparent
    background-image: linear-gradient(40deg, rgb(32, 150, 255), rgb(5, 255, 163)) !important

    .bridge8-popover-header
      color: whitesmoke

  .bridge8-popover-table-cell
    color: darkcyan
    padding-top: 0.25rem
    padding-bottom: 0.25rem

    /*&.bridge8-popover-table-cell-key*/
    /*  font-weight: 500*/
    /*&.bridge8-popover-table-cell-value*/
    /*  font-weight: 700*/
</style>



// WEBPACK FOOTER //
// src/components/Bridge8Popover.vue